module.exports = __webpack_public_path__ + "img/client.5502947d.svg";